var _g, _g2, _g3, _circle, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIprActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_21513_23448)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.2567,
    height: 65.4679,
    rx: 10.254,
    fill: "#898989"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_21513_23448)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 49.6914,
    width: 66.2567,
    height: 15.7754,
    rx: 7.8877,
    fill: "#FCB0B2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21513_23448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3996 16.3848C14.6524 16.7691 13.8242 16.9695 12.984 16.9695C12.1437 16.9695 11.3156 16.7691 10.5684 16.3848C5.72336 13.9002 -4.73047 10.5183 -4.73047 27.5472C-4.73047 38.9719 1.48109 56.6633 5.89821 56.6633C10.3153 56.6633 8.55768 39.0271 12.984 39.0271C17.4103 39.0271 15.6389 56.6633 20.0698 56.6633C24.5007 56.6633 30.6985 38.9719 30.6985 27.5472C30.6985 10.5183 20.2446 13.9002 15.3996 16.3848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2574 14.4922C25.9138 16.4477 27.0181 19.8203 27.0181 25.3601C27.0181 35.6621 21.9799 51.0484 17.7422 53.9793C18.2667 55.5897 18.9661 56.6618 20.0704 56.6618C24.4875 56.6618 30.699 38.9704 30.699 27.5457C30.699 18.4952 27.7497 15.21 24.2574 14.4922Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.048 16.3848C53.3008 16.7691 52.4727 16.9695 51.6324 16.9695C50.7922 16.9695 49.9641 16.7691 49.2168 16.3848C44.3718 13.9002 33.918 10.5183 33.918 27.5472C33.918 38.9719 40.1295 56.6633 44.5466 56.6633C48.9638 56.6633 47.2061 39.0271 51.6324 39.0271C56.0587 39.0271 54.2873 56.6633 58.7182 56.6633C63.1491 56.6633 69.3469 38.9719 69.3469 27.5472C69.3469 10.5183 58.8931 13.9002 54.048 16.3848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3945,
    y: 43.3828,
    width: 7.8877,
    height: 23.6631,
    rx: 3.94385,
    fill: "#373A3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5508,
    y: 29.1875,
    width: 1.57754,
    height: 23.6631,
    rx: 0.78877,
    fill: "#373A3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3945,
    y: 26.8203,
    width: 7.8877,
    height: 7.8877,
    rx: 3.94385,
    fill: "#373A3D"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.7286,
    cy: 10.6504,
    r: 5.12701,
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_21513_23448)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.39033,
    y: 0.792676,
    width: 64.6791,
    height: 63.8904,
    rx: 9.46524,
    stroke: "white",
    strokeWidth: 1.57754
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21513_23448",
    x: -6.31016,
    y: -6.31016,
    width: 78.8781,
    height: 78.0891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.15508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21513_23448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21513_23448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_21513_23448",
    x: -6.31016,
    y: 43.3812,
    width: 78.8781,
    height: 28.3977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.15508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21513_23448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21513_23448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_21513_23448",
    x: -5.7086,
    y: -6.30625,
    width: 78.8781,
    height: 78.0891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.15508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21513_23448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21513_23448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21513_23448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.1711,
    height: 44.1711,
    fill: "white",
    transform: "translate(11.043 13.4102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIprActive);
export default __webpack_public_path__ + "static/media/IPRActive.e8129e9f36169caadac30020c765ccf2.svg";
export { ForwardRef as ReactComponent };